const CompleteGantt = (isSupervisor, task, id, gantt, thiss) => {
  let matchRespAndCurrentUser = thiss.currentUser.EmployeeId == task.created_by;
  // console.log("userr", thiss.currentUser.EmployeeId)
  // console.log("task", task)
  // console.log("wwwww", matchRespAndCurrentUser)
  if (
    !isSupervisor &&
    !matchRespAndCurrentUser
    // thiss.currentUser.EmployeeId != 37 ||
  ) {
    gantt.alert({
      text: "Usted no es el supervisor o superior para poder calificar la tarea.",
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }

  //console.log(task);
  if (
    task.evidence.length == 0 ||
    task.evidence == "" ||
    task.evidence == null
  ) {
    gantt.alert({
      text: "Esta solicitud debe de tener una evidencia y un progreso de 100%, para ser completada",
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }
  thiss.OpenObjeID = task.id;

  thiss.loading = true;
  gantt.hideLightbox();
  if (task.parent.includes("Task")) {
    //SubTasks
    thiss.$http
      .post(`/api/cmi/SubTaskGantt/ApproveEvidenceSubTaskGantt?ID=${task.id}`)
      .then(() => {
        let message = "La Evidencia del objetivo fue aprovada";
        thiss.$message.success(message);
      })
      .catch((err) => {
        thiss.$message({
          type: "error",
          message: err.message
        });
      })
      .finally(() => {
        thiss.GetGanttObjectives();
        // thiss.loading = false;
      });
    return;
  }
  thiss.$http
    .post(`/api/cmi/task/ApproveEvidenceTaskGantt?ID=${task.id}`)
    .then(() => {
      let message = "La Evidencia del objetivo fue aprovada";
      thiss.$message.success(message);
    })
    .catch((err) => {
      thiss.$message({
        type: "error",
        message: err.message
      });
    })
    .finally(() => {
      thiss.GetGanttObjectives();
      // thiss.loading = false;
    });
};

export default CompleteGantt;
